import type { ValueParserParams } from 'ag-grid-community';
import { format, formatISO, isValid, parse, parseISO } from 'date-fns';

import { DATE_FORMAT } from '@/constants';
import type { ValueFormatterParams } from '@/grid/types';

export function dateOnlyFormatter(
  params:
    | { value: string | null | undefined }
    | ValueFormatterParams<unknown, string>,
): string {
  // extract 'YYYY-MM-DD' in case the server is still sending a DateTime
  const dateValue = params.value?.trim().slice(0, 10);
  if (!dateValue) {
    return '';
  }

  const date = parseISO(dateValue);
  if (!isValid(date)) {
    return '';
  }

  return format(date, DATE_FORMAT);
}

export function dateOnlyParser({
  newValue,
}: ValueParserParams<unknown, string>): string {
  const dateValue = newValue?.trim() ?? '';
  const year = dateValue.split('/')[2];
  const date = year
    ? parse(
        dateValue,
        year.length === 4 ? DATE_FORMAT : 'MM/dd/yy',
        new Date(2000, 0, 1),
      )
    : parseISO(dateValue);

  if (date.getFullYear() < 2000 && year?.length === 2) {
    date.setFullYear(2000 + Number.parseInt(year, 10));
  }

  return isValid(date)
    ? formatISO(date, { representation: 'date' })
    : dateValue;
}
